import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  generateUserKey(userID: string): string {
    return CryptoJS.SHA256(userID + "_656565fgf56df45efd458y488475485848dfdrsjddjipspji3h38540584540545dfduh347803").toString();
  }
  
  private messageSource = new BehaviorSubject(false);
  currentMessage = this.messageSource.asObservable();

  private mfaFlowSource = new BehaviorSubject<boolean>(false);
  mfaFlowActive = this.mfaFlowSource.asObservable();

  public walletDateFilterSource = new BehaviorSubject(false);
  currentDateFilter = this.walletDateFilterSource.asObservable();


  public walletExpenseTabSource = new BehaviorSubject(false);
  currentWalletExpenseTab = this.walletExpenseTabSource.asObservable();

  public walletUpdateBalanceSource = new BehaviorSubject(false);
  currentWalletUpdateBalance = this.walletUpdateBalanceSource.asObservable();

  public payFastSuccessSource = new BehaviorSubject(false);
  currentPayFastSuccessValue = this.payFastSuccessSource.asObservable();

  public walletPaymentSuccessSource = new BehaviorSubject<{ gateway: string; paymentReference?: string } | null>(null);
  currentWalletPaymentSuccessValue = this.walletPaymentSuccessSource.asObservable();

  public walletArrearsChargeTableSource = new BehaviorSubject(false);
  currentWalletArrearsChargeTable = this.walletArrearsChargeTableSource.asObservable();

  public resetSideBarMenuSource = new BehaviorSubject(false);
  currentResetSideBarMenu = this.resetSideBarMenuSource.asObservable();

  constructor() { }

  changeMessage(message: boolean) {
    this.messageSource.next(message)
  }

  setMfaFlowActive(active: boolean): void {
    this.mfaFlowSource.next(active);
  }

  notifyMfaFlowCompleted(): void {
    this.mfaFlowSource.next(false);
  }

  resetTariffReviewState(userID?: string | number | null): void {
    sessionStorage.removeItem('pendingApprovalsDismissed');
    sessionStorage.removeItem('pendingApprovalsShownForLogin');
    const activeUserID = userID ?? localStorage.getItem('userID');
    if (activeUserID !== null && activeUserID !== undefined) {
      sessionStorage.removeItem(`pendingApprovalsDismissed:${activeUserID}`);
    }
  }

  changeWalletDateFilter(range:boolean){
    this.walletDateFilterSource.next(range)
  }

  changeTabWalletExpenses(val:boolean){
    this.walletExpenseTabSource.next(val)
  }

  changeUpdateWalletBalance(val:boolean){
    this.walletUpdateBalanceSource.next(val)
  }


  changePayFastSuccessValue(val:boolean){
    this.payFastSuccessSource.next(val)
  }

  changeWalletPaymentSuccessValue(gateway: string, paymentReference?: string){
    this.walletPaymentSuccessSource.next({ gateway, paymentReference })
  }

  changeWalletArrearsChargeTable(val:boolean){
    this.walletArrearsChargeTableSource.next(val)
  }

    resetSideBarMenu(val:boolean){
    this.resetSideBarMenuSource.next(val)
  }

  /* 
  * This function encrypts a value using AES encryption with a user-specific key
  * The key is derived from the userID to ensure that each user's data is encrypted with a unique key
  * The encrypted value is returned as a string in the format "iv:encryptedValue"
  * The IV (initialization vector) is prepended to the encrypted value for decryption purposes
  * The function uses CryptoJS library for encryption
  */ 
  encryptToken(value: any, userID: string): string {
    const iv = CryptoJS.lib.WordArray.random(16);
    const key = CryptoJS.enc.Utf8.parse(this.generateUserKey(userID));
    const encrypted = CryptoJS.AES.encrypt(value, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
  
    return iv.toString(CryptoJS.enc.Base64) + ":" + encrypted.toString();
  }
  
  /* 
  * This function decrypts a value that was encrypted using the encryptToken function
  * It takes the encrypted value and the userID as parameters
  * The encrypted value is expected to be in the format "iv:encryptedValue"
  * The function extracts the IV and the encrypted text, then decrypts it using the same key derived from the userID
  * If decryption fails, it returns an empty string
  */ 
  decryptToken(encryptedValue: any, userID: string): string {
    try {
      if (typeof encryptedValue !== "string") {
        return "";
      }

      const normalizedValue = encryptedValue.trim();
      if (!normalizedValue) {
        return "";
      }

      const parts = normalizedValue.split(":");
      if (parts.length < 2) {
        return normalizedValue;
      }

      const [ivBase64, encryptedText] = parts;
      if (!ivBase64 || !encryptedText) {
        return "";
      }

      const iv = CryptoJS.enc.Base64.parse(ivBase64);
      const key = CryptoJS.enc.Utf8.parse(this.generateUserKey(userID));
      
      const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
  
      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (e) {
      return "";
    }
  }


  formatDate(input: string): string {
  const date = new Date(input);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

}
